import { StorageService } from './storage.service';
import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { IDBPDatabase, openDB } from 'idb';

@Injectable({
  providedIn: 'root',
})
export class WebStorageService extends StorageService {
  private indexedDb: IDBPDatabase<any> | null = null;

  private STORE_NAME: string = 'store';

  constructor(private platform: Platform) {
    super();
  }

  async init() {
    await this.platform.ready();
    this.indexedDb = await this.openIndexedDB();
    console.log('Running on web platform, using IndexedDB for storage');
  }

  async openIndexedDB() {
    const storeName = this.STORE_NAME;
    return openDB('my-db', 1, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(storeName)) {
          db.createObjectStore(storeName);
        }
      },
    });
  }

  async set(key: string, value: any) {
    if (!this.indexedDb) throw new Error('IndexedDB not initialized');
    const valStr = typeof value === 'string' ? value : JSON.stringify(value);
    await this.indexedDb.put(this.STORE_NAME, valStr, key);
  }

  async get(key: string): Promise<any> {
    if (!this.indexedDb) throw new Error('IndexedDB not initialized');
    return await this.indexedDb.get(this.STORE_NAME, key);
  }

  async remove(key: string): Promise<any> {
    if (!this.indexedDb) throw new Error('IndexedDB not initialized');
    await this.indexedDb.delete(this.STORE_NAME, key);
  }

  async clear() {
    if (!this.indexedDb) throw new Error('IndexedDB not initialized');
    await this.indexedDb.clear(this.STORE_NAME);
  }

  async keys() {
    if (!this.indexedDb) throw new Error('IndexedDB not initialized');
    const keys = await this.indexedDb.getAllKeys(this.STORE_NAME);
    return keys.map((key) => String(key));
  }

  async fetchState() {
    if (!this.indexedDb) throw new Error('IndexedDB not initialized');
    const state: Record<string, unknown> = {};
    const keys = await this.keys();
    for (const key of keys) {
      const value = await this.get(key);
      state[key.replace(this.STORAGE_KEY + '-', '')] =
        typeof value === 'string'
          ? value.startsWith('{') || value.startsWith('[')
            ? JSON.parse(value)
            : value
          : value;
    }
    return state;
  }
}
